<template>
  <v-container fluid fill-height>
    <v-row align="center"
    justify="center">
      <v-col cols="12" md="6" lg="5" xl="4">
        <v-img
          :src="require('../../assets/xici-black.svg')"
          class="my-3 d-block"
          contain
          height="90"
        />

        <v-card class="elevation-12 mt-8 mb-16 pb-3" @keydown.enter="login">

          <v-card-title class="navbar white--text">
            {{$t('section.login')}}
          </v-card-title>

          <v-card-subtitle class="navbar white--text text-left mb-6">
            {{$t('info.alert.login')}}
          </v-card-subtitle>

          <v-card-text>
            <v-form>
              <v-text-field
                v-model="username"
                label="Username"
                name="username"
                prepend-icon="person"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="password"
                id="password"
                label="Password"
                name="password"
                prepend-icon="mdi-key-variant"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="login" class="px-4 mx-2"  color="primary">{{$t('button.login')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      fromRoute: undefined,
      showPassword: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from.name;
    });
  },

  methods: {
    handleBack() {
      if (this.fromRoute) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    },
    login: function() {
      let username = this.username;
      let password = this.password;
      this.$store
        .dispatch("login", { username, password })
        .then(resp => {
          this.$i18n.locale = resp.data.user.preferred_language;
          this.$store.dispatch(
            "setLanguage",
            resp.data.user.preferred_language
          );
          const redirectPath = this.$route.query.redirect;
          if (typeof redirectPath === "string" && redirectPath.startsWith("/")) {
            this.$router.push(redirectPath);
          } else {
            this.handleBack();
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 400) {
            this.$store.commit("alert", {
              color: "error",
              text: err.response.data.detail || err.response.data.password[0] || err.response.data.username[0]
            });
          } else {
            this.$store.commit("alert", {
              color: "error",
              text: "An error has occurred. please try again"
            });
          }
        });
    }
  }
};
</script>
